module.exports = __webpack_public_path__ + "media/images/ribbon-714461ebc5bfc11b338d51c224353743.svg";